import React from "react";
import { Stack } from "@bookingcom/bui-react";
import BaggagePolicies from "../../../../../BaggagePolicies/index.js";
import { BaggageSegmentDesktop } from "../../../../../IncludedBaggage/components/BaggageSegment.desktop.js";
import { FlightDetailsInfoDesktopUI } from "../../../../../../ui/FlightDetails/FlightDetailsInfo.desktop.ui.js";
import { useI18n, t } from "@bookingcom/lingojs-react";
export default function BaggageInfoDesktop(props) {
    const { baggageData, baggagePolicies, flightSegments } = props;
    const i18n = useI18n();
    if (!baggageData && !baggagePolicies)
        return null;
    return (React.createElement(Stack, null,
        baggageData ? (React.createElement(FlightDetailsInfoDesktopUI, null,
            React.createElement(FlightDetailsInfoDesktopUI.Title, null, i18n.trans(t("flights_fd_baggage_total_included"))),
            baggageData.segments.map((baggageSegment, index) => {
                if (baggageSegment.length > 0) {
                    return (React.createElement("div", { key: index, "data-testid": `included_baggage_${index}` },
                        React.createElement(BaggageSegmentDesktop, { flightSegment: flightSegments[index], baggageSegment: baggageSegment, showHeader: !baggageData.areAllSegmentsIdentical, hideIncludedSection: true })));
                }
                else {
                    return null;
                }
            }))) : undefined,
        baggagePolicies ? React.createElement(BaggagePolicies, { baggagePolicies: baggagePolicies }) : undefined));
}
